/* ── Boss Bidet Revolution V2 — patch layer 2 (2026-07-25) ──
   1. Adds an FAQ link to the landing page nav (between Shop and Login),
      anchored to the on-page FAQ section
   2. Flattens the two-line mini-feature labels ("Auto<br>Shut off") to one
      line so they read as pill chips (styled by bb-rev2-y.css) */

(function () {
  'use strict';

  function init() {
    /* 1 ── FAQ in the nav */
    var right = document.querySelector('.bb-landing .bb-nav-right');
    if (right && !right.querySelector('[data-bb-faq-link]')) {
      var faq = document.createElement('a');
      faq.href = '#shopify-section-bb-rev2-faq';
      faq.className = 'bb-nav-link';
      faq.setAttribute('data-bb-faq-link', '');
      faq.textContent = 'FAQ';
      var login = right.querySelectorAll('.bb-nav-link')[1] || null;
      right.insertBefore(faq, login);
    }

    /* 2 ── One-line mini-feature labels */
    document.querySelectorAll('.bb-mini-feat-label br').forEach(function (br) {
      br.replaceWith(' ');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
